import { useMutation } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";
import { toast } from "sonner";
import usePricingModal, { PAYWALL_TYPES } from "@/lib/hooks/use-pricing-modal";
import { useScopedI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

export const useCreatePracticeTest = () => {
  const trpc = useTRPC();
  const t = useScopedI18n("practiceTest");
  const posthog = usePostHog();
  const { onOpen: openPricingModal } = usePricingModal();

  return useMutation(
    trpc.practiceTests.create.mutationOptions({
      onError: (error, variables) => {
        if (error.message === "Reached Free Plan Practice Test Length") {
          openPricingModal({
            upgradeReason: "Practice test length limit reached",
            paywallType: PAYWALL_TYPES.PRACTICE_TEST_LENGTH,
          });
          return;
        }
        if (error.message === "Reached Free Plan Practice Test Limit") {
          openPricingModal({
            upgradeReason: "Practice test limit reached",
            paywallType: PAYWALL_TYPES.PRACTICE_TEST_LIMIT,
          });
          return;
        }
        if (error.message === "Content not analyzed for practice tests") {
          posthog?.capture("practice_test_blocked_legacy_content", {
            studySetId: variables.studySetId,
            folderId: variables.folderId,
          });
          toast.error(t("setup.notAnalyzed"), {
            description: t("setup.notAnalyzedHint"),
          });
          return;
        }
        toast.error("Couldn't create practice test", {
          description: error.message,
        });
      },
    }),
  );
};
